import { useEffect, useState } from 'react';

// Below this width the site switches to its mobile layout: hamburger menu
// instead of the desktop side rail, and Google's bottom sign-in prompt.
export const MOBILE_QUERY = '(max-width: 1023px)';

export const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
    useEffect(() => {
        const mq = window.matchMedia(query);
        const onChange = () => setMatches(mq.matches);
        onChange();
        mq.addEventListener('change', onChange);
        return () => mq.removeEventListener('change', onChange);
    }, [query]);
    return matches;
};

export const useIsMobile = () => useMediaQuery(MOBILE_QUERY);
